const REASONS = [
  { icon: 'ri-water-flash-line', text: 'Walking distance to Glen Falls waterfall' },
  { icon: 'ri-award-line', text: 'Top 5% Airbnb Guest Favorite' },
  { icon: 'ri-paw-print-line', text: 'Pet-friendly luxury cabin' },
  { icon: 'ri-home-heart-line', text: 'Private and peaceful setting' },
  { icon: 'ri-map-pin-2-line', text: 'Close to downtown Highlands' },
];

export default function GlenFallsWhyStay() {
  return (
    <section className="bg-[#FAFAF8] py-20 px-6 lg:px-14 border-t border-[#EDE8E0]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-14">

          {/* Left: content */}
          <div className="w-full lg:w-1/2">
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-5">
              / Top Pick
            </p>
            <h2 className="font-cormorant text-4xl lg:text-5xl text-[#1A1A18] font-light leading-tight mb-3">
              Why Stay at<br />
              <em className="italic">Glen Falls Luxury Cabin</em>
            </h2>
            <p className="text-[#9C9890] font-jost text-sm mb-8">
              Glen Falls Luxury Cabin in Highlands, NC
            </p>

            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-5">
              Positioned just minutes from the trailhead, <strong className="text-[#2D4A3E] font-medium">Glen Falls Luxury Cabin in Highlands, NC</strong> is one of the few rentals in the area that genuinely earns the description "near Glen Falls." The trail is walkable from the property — no car needed, no extra logistics. Guests who travel to Highlands specifically for the falls consistently name it as their first choice for where to stay.
            </p>

            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-5">
              What sets this cabin near Glen Falls Highlands NC apart isn't proximity alone. As a <em>luxury cabin near waterfalls in Highlands</em>, it pairs genuine trail access with accommodations most visitors spend their whole trip wishing they had — a stone indoor fireplace, covered outdoor living spaces, and surroundings quiet enough to hear the forest at night. Location and experience reinforce each other in a way that's rare among Highlands rentals.
            </p>

            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-8">
              That combination is why <strong className="text-[#2D4A3E] font-medium">Glen Falls Luxury Cabin in Highlands, NC</strong> is consistently recognized among the best cabins near Glen Falls waterfall — not through marketing, but through the kind of five-star guest experiences that earn Top 5% Airbnb status year after year.
            </p>

            <ul className="space-y-4 mb-10">
              {REASONS.map((reason) => (
                <li key={reason.text} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                    <i className={`${reason.icon} text-[#2D4A3E] text-base`} />
                  </div>
                  <span className="text-[#5C5850] font-jost text-sm leading-relaxed pt-1.5">
                    {reason.text}
                  </span>
                </li>
              ))}
            </ul>

            <a
              href="https://glenfallscabin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-10 py-4 rounded-full hover:bg-[#1e3329] transition-colors cursor-pointer whitespace-nowrap"
            >
              Book Direct
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </a>
          </div>

          {/* Right: image + stat cards */}
          <div className="w-full lg:w-1/2 relative">
            <div className="rounded-2xl overflow-hidden h-[440px]">
              <img
                src="https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/49c951c183cda9feec32b1509287ef64.jpeg"
                alt="Glen Falls Luxury Cabin in Highlands, NC — interior living room with stone fireplace"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating stat card */}
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl px-6 py-5 shadow-none border border-[#EDE8E0]">
              <div className="flex items-center gap-3 mb-1">
                {[1,2,3,4,5].map((i) => (
                  <div key={i} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A96E] text-xs" />
                  </div>
                ))}
              </div>
              <p className="font-cormorant text-2xl text-[#1A1A18] font-medium">5.0 Stars</p>
              <p className="text-[#9C9890] text-xs font-jost mt-0.5">Airbnb Guest Favorite</p>
            </div>

            {/* Top badge */}
            <div className="absolute top-5 right-5 bg-[#2D4A3E] text-white text-xs font-jost tracking-[0.15em] uppercase px-4 py-2 rounded-full flex items-center gap-2">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-award-line text-[#C9A96E] text-xs" />
              </div>
              Top 5% of Homes
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
